import { useEffect, useState } from "react";
import { PortalShell } from "@/components/AppHeader";
import { TripTable } from "@/components/TripTable";
import { api } from "@/lib/api";

const Stat = ({ label, value, testId }) => (
  <div className="lux-card p-6">
    <p className="lux-eyebrow">{label}</p>
    <p data-testid={testId} className="mt-3 font-serif text-3xl text-amber-50">{value}</p>
  </div>
);

export default function DriverTrips() {
  const [trips, setTrips] = useState(null);
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    api.get("/trips").then(({ data }) => setTrips(data));
    api.get("/driver/summary").then(({ data }) => setSummary(data));
  }, []);
  return (
    <PortalShell>
      <p className="lux-eyebrow">History</p>
      <h1 className="mt-2 text-3xl font-semibold text-amber-50 sm:text-4xl">My trips</h1>
      {summary && (
        <div className="mt-8 grid gap-4 sm:grid-cols-3">
          <Stat label="Lifetime total miles" value={`${summary.lifetime_total_miles} mi`} testId="driver-lifetime-miles" />
          <Stat label="Completed trips" value={summary.completed_trips} testId="driver-completed-trips" />
          <Stat label="Trip / pickup miles" value={`${summary.lifetime_trip_miles} / ${summary.lifetime_pickup_miles}`} testId="driver-trip-pickup-miles" />
        </div>
      )}
      <div className="lux-card mt-6 p-2 sm:p-4" data-testid="driver-trip-history">
        {trips && <TripTable trips={trips} showCustomer testId="driver-trips-table" />}
      </div>
    </PortalShell>
  );
}
